import { MultiMaterialCompositeDto } from './multi-material-composite-dto';
import { ImportCandidateDto } from '../import-candidate-dto';

export class ImportMaterialCandidateDto extends ImportCandidateDto {
    multiMaterial!: MultiMaterialCompositeDto;
}
